import { render, staticRenderFns } from "./BankAccountDetail.vue?vue&type=template&id=7f6033fb&"
import script from "./BankAccountDetail.vue?vue&type=script&lang=js&"
export * from "./BankAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports